// extracted by mini-css-extract-plugin
export default {"mainSection":"titledsection_mainSection__YaUGT","title":"titledsection_title__rOLlb","actions":"titledsection_actions__6rUFh","content":"titledsection_content__aVt7Y"};